import React from 'react';
import clsx from 'clsx';
import styles from './Drawer.module.scss';

const Drawer = ({
  isOpen,
  onToggle,
  children,
  direction,
  width,
  ...otherProps
}) => {
  return (
    <>
      <section
        style={{ width }}
        className={clsx(
          styles.drawer,
          isOpen && styles.isOpen,
          direction === 'left' && styles.isLeft,
          direction === 'right' && styles.isRight
        )}
        {...otherProps}
      >
        {children}
      </section>
      <div
        className={clsx(styles.backdrop, isOpen && styles.isOpen)}
        onClick={onToggle}
      ></div>
    </>
  );
};

export default Drawer;
